var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer"},_vm._l((_vm.btnGroup),function(item,index){return _c('div',{key:index,staticClass:"box",class:[{'active':_vm.currentIndex==item.id},item.icon],on:{"click":function($event){_vm.goTo(item.id, item.path)}}},[_c('i',{staticClass:"glyphicon",class:'glyphicon-'+item.icon}),_vm._v("\n    "+_vm._s(item.name)+"\n  ")])}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2e59b8b4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Footer.vue
// module id = null
// module chunks = 